import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-vehicle-tab',
  templateUrl: './vehicle-tab.component.html',
  styleUrls: ['./vehicle-tab.component.scss']
})
export class VehicleTabComponent implements OnInit {

  public id;

  constructor(
    public menu: MenuService,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
  }

}
